export default "__VITE_ASSET__C942CB2q__"